module.exports = __webpack_public_path__ + "static/media/gameweek-loser.24d85cb9.png";